webpackJsonp([1],{

/***/ "FQ0Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-head/vue-head.js
var vue_head = __webpack_require__("RZCy");
var vue_head_default = /*#__PURE__*/__webpack_require__.n(vue_head);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Quiz.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var questions = [{
  text: "Каким ты представляешь свой идеальный отпуск?",
  answers: [{ text: 'Обширная развлекательная программа в шумной европейской столице с компанией друзей', value: 1 }, { text: 'Пропущу отпуск чтобы сэкономить или перенесу трудовую вахту на дачный участок', value: 0 }]
}, {
  text: "На волне очередного глобального финансового кризиса все кинулись тратить сбережения, Как ты поступишь со своими?",
  answers: [{ text: 'Куплю одежду и гаджеты, которые давно хотел(', value: 0 }, { text: 'Вложу в перспективную криптовалюту!', value: 1 }]
}, {
  text: "От каких ежедневных мелких расходов ты готов(а) отказаться в пользу",
  answers: [{
    text: 'Готов(а) отказаться от утреннего каппучино в кофейне или иногда брать обед на работу из дома',
    value: 1
  }, { text: 'Не готов(а) отказываться ни от чего, ведь комфорт и состоит из этих мелочей', value: 0 }]
}, {
  text: "На какой статье расходов ты не готов(а) экономить, вне зависимости от глобальных финансовых кризисов и приближающийся отпуск?",
  answers: [{ text: 'Новые кроссовки', value: 1 }, { text: 'Бары и рестораны', value: 0 }]
}, {
  text: "Получается ли у тебя выполнять данные себе обещания — например, похудеть к лету или начать бегать после нового года?",
  answers: [{ text: 'Нет, мой энтузиазм быстро заканчивается', value: 0 }, { text: 'Да, я стараюсь добиваться своей цели ', value: 1 }]
}, {
  text: "В интернете снова кто-то неправ. Твои действия?",
  answers: [{ text: 'Всю ночь строчу гневные комментарии и собираю армию анонимов для масштабных кибер-разборок ', value: 0 }, { text: 'Будут всегда, не стоит тратить на них нервы ', value: 1 }]
}, {
  text: "Привык ли ты планировать свои финансы и вести домашнюю бухгалтерию? ",
  answers: [{ text: 'Да', value: 20, flag1: true }, { text: 'Нет', value: 0 }]
}, {
  text: "Есть ли у тебя банковские вклады?",
  answers: [{ text: 'Да', value: 18, flag2: true }, { text: 'Нет', value: 0 }]
}, {
  text: "Ты уже задумывался(ась) о возможных источниках дохода после выхода на пенсию?",
  answers: [{ text: 'Да, ведь с годами время летит все быстрее ', value: 12 }, { text: 'Нет, я еще слишком молод(а)', value: 0 }]
}, {
  text: "Знаешь ли ты, как устроены негосударственные пенсионные фонды?",
  answers: [{ text: 'Да, представляю, что это за инструмент', value: 10 }, { text: 'Нет, не в курсе, что это', value: 0 }]
}];
var results = [{
  id: 1,
  title: "Ветеран культуры",
  text: "Бабушки и дедушки твоего типа много времени посвящает детям и внукам, но, прежде всего, уделяют внимание своим культурным и духовным потребностям <span class='desk'> и проводят годы заслуженного отдыха, имея почти безграничный доступ к любым новым знаниям и впечатлениям. Твои внуки знают, что на театральные премьеры всегда будут куплены лучшие билеты, ведь твое светское расписание составляется на три месяца вперед, а интерес к происходящему в мире не угасает никогда</span>."
}, {
  id: 2,
  title: "Old Fashion",
  text: "<span class='desk'>Ты — гордость детей и внуков, вечный(ая) герой(героиня) всех стрит-стайл блогов и муза светских фотографов, поэтому для тебя всегда была и остается важной возможность обновлять гардероб и поддерживать спортивную форму. </span>Твоя суперсопособность — умение принимать людей такими, какие они есть, при этом считая возможные недостатки всего лишь особенностями, подчеркивающими индивидуальность.\n",
  subText: "*Старый модник"
}, {
  id: 3,
  title: "Пожилой нормкорщик",
  text: "Бытовой комфорт и достаток для тебя будут всегда важнее новых ощущений и эмоций. Ты — редкий пример пенсионера(ки), к которому(ой) младшие члены семьи не просто прислушиваются, а буквально выстраиваются в очередь за житейским советом<span class='desk'>, который никогда не будет дан с позиции осуждения. Ты давно и успешно нашел(нашла) себя, и пока есть деньги на счету, жить сбалансированной жизнью по средствам, при этом не отказывая себе в излюбленном досуге</span>."
}, {
  id: 4,
  title: "Пенсионерская классика ",
  text: "В одежде ты предпочитаешь комфортную пенсионерскую классику, а проводить добрую половину дня любишь сидя на лавке у подъезда с коллегами-скамеечниками. <span class='desk'>Наблюдения за более активной частью населения ты снабжаешь советами и нравоучениями, а твое любимое развлечение — наблюдать лица прохожих, ошарашенных высокими нравственными требованиями, предъявляемыми тобой роду человеческому. </span>"
}];
var faq = [{
  collapsed: false,
  q: "Ну это же для пенсионеров? Я-то еще молодой!",
  a: "Самое время побеспокоиться о своем будущем! Не забывайте, что пенсионная система России обеспечивает только минимальный прожиточный уровень (в среднем 13 000 руб. в месяц). И что вы на них купите в старости? Представьте, что вам придется отказаться от всего, к чему вы привыкли и так любите: чашка  любимого кофе, отпуск на  курорте, прогулки по новым местам. Не страшно? Поэтому, чем раньше начать копить, тем эффективней будет ваш индивидуальный пенсионный план. Начать можно с небольшой суммы, например с 500 рублей в месяц."

}, {
  collapsed: false,
  q: "Допустим, вы меня заинтересовали. А что с доходностью?\n",
  a: "На практике средняя доходность НПФ превышает инфляцию и является одной из самых высоких на финансовых рынках. Также не забывайте про 13-процентный возврат подоходного налога при уплате взносов (но не более 120 000 рублей в год). То есть, если вы внесли 120 000 рублей в год, то 15 600 рублей можно вернуть через налоговую или через работодателя (подав заявление в бухгалтерию).\n" + "\n"
}, {
  collapsed: false,
  q: "А если со мной что-то (стучу по дереву) случится? Денежки тю-тю?\n",
  a: "Конечно, нет. Если с вами что-то случится (стучим в ответ), то наследники получают до 100% вложений и накопленного инвестиционного дохода в соответствии с Правилами Фонда.\n" + "\n"
}, {
  collapsed: false,
  q: "А не проще ли мне купить квартиру или копить деньги в банке?\n",
  a: "Квартиру купить? Ну на это сразу нужен мешок денег. У вас он есть? Что же до накоплений в банках, то, например, максимальный срок депозита около 3 лет (очень редко банки делают депозиты на 5 лет), и он хорош для целевого накопления на год или три вперед. К тому же по нему не предоставляется налоговый вычет, да и снимать его придется полностью, либо получать проценты (при этом основная сумма будет лежать в банке). А по пенсионному плану вы можете выбрать срочную выплату (5-20 лет), либо пожизненную, причем сумма выплат будет индексироваться ежегодно.\n" + "\n"
}, {
  collapsed: false,
  q: "Посоветуйте мне оптимальную стратегию накопления",
  a: 'Оптимальная стратегия для каждого своя, но общее направление может быть такое:<br>- внести первый взнос (от 1500 рублей)<br>- подключить автоплатеж на комфортную для вас сумму и каждый год увеличивать его на 10-30% (в зависимости от возможностей)<br>- каждый год получать налоговый вычет по ИПП и вносить его на свой пенсионный счет в виде единовременного взноса<br> - в случае получения доп. доходов (премия, гонорар и т.д.) при возможности вносить разовые платежи на пенсионный счет на комфортные для вас суммы Как видите все очень просто.\n' + '\n'
}, {
  collapsed: false,
  q: "Хорошо, куда идти за индивидуальным пенсионным планом?",
  a: "Оформить ИПП можно в отделениях Сбербанка или на сайте НПФ Сбербанка, для заключения договора на сайте нужно заполнить свои данные и уплатить первый взнос с помощью банковской карты. Так же на сайте можно подключить автоплатеж для пополнения своего пенсионного счета.\n" + "\n"
}];


/* harmony default export */ var Quiz = ({
  name: "quiz",
  data: function data() {
    return {
      state: 0,
      questionIndex: 0,
      faq: faq,
      questions: questions,
      results: results,
      score: 0,
      flag1: false,
      flag2: false

    };
  },

  components: {
    VueHead: vue_head_default.a
  },
  head: {
    title: {
      inner: 'Викторина'
    },
    meta: function meta() {
      return [{ p: 'og:title', c: this.quizResult.title },
      // {p: 'og:description', c: RESULTS[this.id]},
      { p: 'og:image', c: '/static/img/share/' + this.quizResult.id + ".png" }, { p: 'og:site_name', c: '' }];
    }
  },
  computed: {

    counterText: function counterText() {
      return "Вопрос " + (this.questionIndex + 1) + " из " + this.questions.length;
    },
    questionText: function questionText() {
      return this.questions[this.questionIndex].text;
    },
    questionClass: function questionClass() {
      return "question-" + (this.questionIndex + 1);
    },
    resultClass: function resultClass() {
      return "result-" + this.quizResult.id;
    },
    quizResult: function quizResult() {
      if (this.score >= 15 || this.flag1 && this.flag2) {
        return this.results[0];
      }
      if (this.score >= 10 || this.flag1) {
        return this.results[1];
      }
      if (this.score >= 5 || this.flag2) {
        return this.results[2];
      }
      return this.results[3];
    },
    showStar: function showStar() {
      return this.quizResult.subText != undefined;
    },
    vkShareLink: function vkShareLink() {
      return "https://vk.com/share.php?url=http://npfsberbankatest.lenta.ru/&title=Мой результат: " + this.quizResult.title + "&image=http://npfsberbankatest.lenta.ru/static/img/share/" + this.quizResult.id + ".png&noparse=true";
    }
  },
  methods: {
    faqClass: function faqClass(i) {
      return this.faq[i].collapsed ? "" : "collapsed";
    },
    toggleCollapsation: function toggleCollapsation(i) {
      this.faq[i].collapsed = !this.faq[i].collapsed;
    },
    shareClick: function shareClick(method) {},
    nextState: function nextState() {
      this.state++;
    },

    response: function response(value, f1, f2) {
      this.score += value;
      this.flag1 = f1 ? f1 : this.flag1;
      this.flag2 = f2 ? f2 : this.flag2;

      if (this.questionIndex + 1 == this.questions.length) {
        this.nextState();
        return true;
      } else {
        this.questionIndex++;
      }
    },
    startNewQuiz: function startNewQuiz() {
      this.questionIndex = 0;
      this.score = 0;
      this.flag1 = false;
      this.flag2 = false;
      this.state = 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cbac0ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quiz.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 0),expression:"state === 0"}],staticClass:"intro-block"},[_c('div',{staticClass:"image-block"}),_vm._v(" "),_c('div',{staticClass:"text-block"},[_c('div',{staticClass:"muted"},[_vm._v("Тест")]),_vm._v(" "),_c('h1',[_vm._v("Какой пенсионер из тебя получится?")]),_vm._v(" "),_c('p',[_vm._v("Модная борода и стаканчик кофе на вынос в руке или уютный ватник на плечах и хозяйственная сумка-тележка в\n        качестве аксессуара? Пройди тест и узнай, каким пенсионером ты будешь!")]),_vm._v(" "),_c('button',{attrs:{"onclick":"ga('button', 'click', 'start_test')"},on:{"click":_vm.nextState}},[_vm._v("НАЧАТЬ ТЕСТ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 1),expression:"state === 1"}],staticClass:"question-block ",class:_vm.questionClass},[_c('div',{staticClass:"question"},[_c('div',{staticClass:"counter"},[_vm._v(_vm._s(_vm.counterText))]),_vm._v(" "),_c('div',{staticClass:"question-text"},[_vm._v(_vm._s(_vm.questionText))]),_vm._v(" "),_c('div',{staticClass:"answers"},_vm._l((_vm.questions[_vm.questionIndex].answers),function(answer){return _c('div',{staticClass:"answer",attrs:{"data-value":answer.value,"data-f1":answer.flag1,"data-f2":answer.flag2},on:{"click":function($event){_vm.response(answer.value,answer.flag1,answer.flag2)}}},[_vm._v(_vm._s(answer.text)+"\n        ")])}))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === 2),expression:"state === 2"}],staticClass:"result-block",class:_vm.resultClass},[_c('div',{staticClass:"result-intro"},[_c('div',{staticClass:"result-text"},[_c('div',{staticClass:"muted"},[_vm._v("Результат")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.quizResult.title)),_c('sup',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStar === true),expression:"showStar === true"}]},[_vm._v("*")])]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.quizResult.text)}}),_vm._v(" "),_c('div',{staticClass:"sharing"},[_c('a',{attrs:{"target":"_blank","href":'https://vk.com/share.php?url=http://npfsberbankatest.lenta.ru/result'+_vm.quizResult.id+'.html'},on:{"click":function($event){_vm.shareClick('VK')}}},[_c('i',{staticClass:"icon-vkontakte"})]),_vm._v(" "),_c('a',{attrs:{"href":'https://twitter.com/intent/tweet?url=http://npfsberbankatest.lenta.ru/result'+_vm.quizResult.id+'.html',"target":"_blank"},on:{"click":function($event){_vm.shareClick('TW')}}},[_c('i',{staticClass:"icon-twitter"})]),_vm._v(" "),_c('a',{attrs:{"href":'https://www.facebook.com/dialog/share?app_id=1458967624164016&display=popup&href=http://npfsberbankatest.lenta.ru/result'+_vm.quizResult.id+'.html',"target":"_blank"},on:{"click":function($event){_vm.shareClick('FB')}}},[_c('i',{staticClass:"icon-facebook"})]),_vm._v(" "),_c('a',{attrs:{"href":'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=http://npfsberbankatest.lenta.ru/result'+_vm.quizResult.id+'.html',"target":"_blank"},on:{"click":function($event){_vm.shareClick('OK')}}},[_c('i',{staticClass:"icon-odnoklassniki"})])]),_vm._v(" "),_c('button',{attrs:{"onclick":"ga('button', 'click', 'start_again')"},on:{"click":_vm.startNewQuiz}},[_c('i',{staticClass:"icon-cw-1"}),_vm._v("Начать заново")]),_vm._v(" "),_c('div',{staticClass:"bot-text"},[_vm._v("Узнай, как и в старости\n          ни в чем себе не отказывать\n        ")]),_vm._v(" "),_c('div',{staticClass:"arrow"})]),_vm._v(" "),_c('div',{staticClass:"sub-text"},[_vm._v("\n        "+_vm._s(_vm.quizResult.subText)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"result-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"calc-block"},[_c('div',{staticClass:"npf-page"},[_c('div',{staticClass:"npf-container"},[_c('div',{staticClass:"npf-ipp-calc _margin-bottom_50"},[_c('ipp-calculator-component',{attrs:{"data-confirm-link":"http://www.npfsberbanka.ru/ipp/"}},[_c('div',{staticClass:"npf-loader npf-loader__root npf-loader_active"})])],1)])])]),_vm._v(" "),_c('div',{staticClass:"faq"},_vm._l((_vm.faq),function(item,key,index){return _c('div',{staticClass:"faq-item",class:_vm.faqClass(key),on:{"click":function($event){_vm.toggleCollapsation(key)}}},[_c('h2',[_vm._v(_vm._s(item.q))]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(item.a)}})])})),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-1"},[_c('div',{staticClass:"w1"},[_c('h1',[_c('a',{staticStyle:{"text-decoration":"underline"},attrs:{"href":"http://www.npfsberbanka.ru/ipp/?utm_campaign=&utm_source=rambler&utm_medium=cpm&utm_content=test_ipp"}},[_vm._v("Индивидуальный пенсионный план (ИПП)")]),_vm._v(" — это программа для удобного накопления на свою будущую пенсию, вне\n            зависимости от государственной пенсионной системы.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            То есть, в случае с обычной пенсией вам платит государство, в случае с ИПП – вы сами можете вносить\n            деньги,\n            согласно любому удобному для вас графику, например, 1 раз в 2 месяца. Иначе говоря – это ваши частные\n            накопления на безбедный отдых.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"muted"},[_vm._v("Калькулятор")]),_vm._v(" "),_c('h1',{staticClass:"center"},[_vm._v("\n          Выбери свое будущее\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"http://www.npfsberbanka.ru/ipp/?utm_campaign=&utm_source=rambler&utm_medium=cpm&utm_content=test_knopka"}},[_c('img',{attrs:{"src":"/static/img/bot-logo.png","alt":"","width":"240px","height":"44"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Quiz = (esExports);
// CONCATENATED MODULE: ./src/components/Quiz.vue
function injectStyle (ssrContext) {
  __webpack_require__("FQ0Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cbac0ab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Quiz,
  components_Quiz,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Quiz = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Quiz: src_components_Quiz
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64830e0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Quiz')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("rwHq")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "rwHq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ce5eb8188805693be8de.js